import { defineStore } from "pinia";

export const useDialogueStore = defineStore("dialogue", {
  state: () => ({
    dialogue: {},
  }),
  getters: {},
  actions: {},
});
